export default "__VITE_ASSET__58fe1d67__"